import { useMemoizedContentGetter } from 'utils/contentful'
import { Typography } from 'components/Contentful'
import Section from 'components/Section'
import { Box } from '@achieve/ascend'
import classNames from 'classnames'

const AboutUsHero = ({ content }) => {
  const { aboutUsHeroTitle, aboutUsHeroSubTitle, aboutUsHeroImage } = useMemoizedContentGetter(
    content,
    ['aboutUsHeroTitle', 'aboutUsHeroSubTitle', 'aboutUsHeroImage']
  )
  return (
    <Section
      data-testid="about-us-hero-section"
      className={'relative overflow-hidden h-[485px] flex items-center'}
      contain={false}
      mediaContent={aboutUsHeroImage?.mediaContent}
      middleMediaContent={aboutUsHeroImage?.mobileMediaContent}
      mobileMediaContent={aboutUsHeroImage?.mobileMediaContent}
      full
    >
      <Box className={'h-full w-full'} data-testid="about-us-hero-background">
        <div
          className={classNames(
            'h-full w-full flex flex-col justify-center relative px-12 py-0 lg:items-end lg:p-0 lg:bg-none 2xl:pr-[146px]',
            '[background:linear-gradient(344.37deg,rgb(0_0_0_/_72.9%)_0%,rgb(0_0_0_/_39.2%)_73.79%,rgb(0_0_0_/_0%)_101.87%)]'
          )}
        >
          <div className={'lg:w-[485px] lg:max-w-[485px] 2xl:w-[585px] 2xl:max-w-[585px]'}>
            <Typography
              content={aboutUsHeroTitle?.textContent}
              className={classNames(
                'text-center lg:text-left',
                'headingLg lg:displayXl !font-bold text-neutral-0 lg:text-neutral-900'
              )}
              data-testid="about-us-hero-title"
            />
            <Typography
              content={aboutUsHeroSubTitle?.textContent}
              data-testid="about-us-hero-subtitle"
              className={classNames(
                'text-center mt-3 lg:text-left lg:mt-10',
                'headingMd !font-light lg:font-medium text-neutral-0 lg:text-neutral-900'
              )}
            />
          </div>
        </div>
      </Box>
    </Section>
  )
}
export { AboutUsHero }
export default AboutUsHero
